import React, { useContext, useEffect } from "react";
import { ThemeContext } from "../context/ThemeContext";

export default function ThemeSwitcher() {
    const [isDark, setIsDark] = useContext(ThemeContext);
    useEffect(() => {
        if (isDark) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
    }, [isDark]);
    const handleClick = () => {
        setIsDark(!isDark);
    };
    return (
        <label htmlFor="theme" className="theme" onClick={handleClick}>
            <span className="theme__toggle-wrap">
                <input
                    id="theme"
                    className="theme__toggle"
                    type="checkbox"
                    role="switch"
                    name="theme"
                    value="dark"
                />
                <span className="theme__fill"></span>
                <span className="theme__icon">
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                    <span className="theme__icon-part"></span>
                </span>
            </span>
        </label>
    );
}
